<template>
    <div class="row mb-2">
        <b-card class="col-12 mb-2" no-body>
            <b-card-body>
                <input class="form-control mb-2" type="search" id="memberSearch" placeholder="Member Search..." v-model="userSearch" />
                <div class="row">
                    <div class="col-1 text-left">
                        <button v-if="members.current_page > 1" type="button" class="btn btn-sm btn-secondary" @click="firstPageFunc()"><i class="fas fa-fw fa-chevron-double-left fa-fw"></i></button>
                        <button v-else type="button" class="btn btn-sm btn-secondary disabled" disabled><i class="fas fa-fw fa-chevron-double-left fa-fw"></i></button>
                        <button v-if="members.current_page > 1" type="button" class="btn btn-sm btn-secondary" @click="prevPageFunc()"><i class="fas fa-fw fa-chevron-left fa-fw"></i></button>
                        <button v-else type="button" class="btn btn-sm btn-secondary disabled" disabled><i class="fas fa-fw fa-chevron-left fa-fw"></i></button>
                    </div>
                    <div class="col text-center">
                        <span>Page {{ members.current_page || '1' }} / {{ members.last_page || '1' }}</span>
                    </div>
                    <div class="col-1 text-right">
                        <button v-if="members.current_page != members.last_page" type="button" class="btn btn-sm btn-secondary" @click="nextPageFunc()"><i class="fas fa-fw fa-chevron-right fa-fw"></i></button>
                        <button v-else type="button" class="btn btn-sm btn-secondary disabled" disabled><i class="fas fa-fw fa-chevron-right fa-fw"></i></button>
                        <button v-if="members.current_page != members.last_page" type="button" class="btn btn-sm btn-secondary" @click="lastPageFunc()"><i class="fas fa-fw fa-chevron-double-right fa-fw"></i></button>
                        <button v-else type="button" class="btn btn-sm btn-secondary disabled" disabled><i class="fas fa-fw fa-chevron-double-right fa-fw"></i></button>
                    </div>
                </div>
            </b-card-body>
        </b-card>
        <template v-if="members">
            <member-card v-for="member of members.data" :key="member.id" :member="member" @member-deleted="reloadPage()"></member-card>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        memberData: {
            default: false
        }
    },
    data() {
        return {
            userSearch: null,
            members: false,
            firstPage: false,
            prevPage: false,
            nextPage: false,
            lastPage: false,
            currentPage: "/member?getData=true",
            searchTimeout: false,
            memberInterval: false,
        };
    },
    watch: {
        currentPage() {
            this.getMemberData(this.currentPage);
        },
        userSearch() {
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout);
                this.searchTimeout = false;
            }

            this.searchTimeout = setTimeout(() => {
                if (this.userSearch.length) {
                    this.currentPage = "/member?getData=true&search=" + this.userSearch;
                } else {
                    this.currentPage = "/member?getData=true";
                }

                clearTimeout(this.searchTimeout);
                this.searchTimeout = false;
            }, 750);
        },
    },
    methods: {
        getMemberData(url) {
            axios.get(url)
            .then(result => {
                this.members = result.data;
                this.firstPage = this.members.first_page_url ? this.members.first_page_url : false;
                this.prevPage = this.members.prev_page_url ? this.members.prev_page_url : false;
                this.nextPage = this.members.next_page_url ? this.members.next_page_url : false;
                this.lastPage = this.members.last_page_url ? this.members.last_page_url : false;
            })
            .catch(err => {
                console.error(err);
            });
        },
        reloadPage() {
            this.getMemberData(this.currentPage);
        },
        nextPageFunc() {
            this.currentPage = this.nextPage;
        },
        prevPageFunc() {
            this.currentPage = this.prevPage;
        },
        firstPageFunc() {
            this.currentPage = this.firstPage;
        },
        lastPageFunc() {
            this.currentPage = this.lastPage;
        },
    },
    mounted() {
        this.getMemberData(this.currentPage);

        this.memberInterval = setInterval(() => {
            this.getMemberData(this.currentPage);
        }, 30000);
    },
    beforeDestroy() {
        clearInterval(this.memberInterval);
    }
};
</script>